import { configureStore as rtkConfigureStore } from "@reduxjs/toolkit";
import { persistStore, persistReducer } from "redux-persist";
import storage from "redux-persist/lib/storage";
import { rootReducer } from "./rootReducer.js";

export const configureStore = () => {
    const persistConfig = {
        key: "root",
        storage,
        whitelist: ['auth', 'userSlice'],
        transforms: [],
    };
    const persistedReducer = persistReducer(persistConfig, rootReducer);

    const store = rtkConfigureStore({
        reducer: persistedReducer,
        middleware: (getDefaultMiddleware) =>
            getDefaultMiddleware({
                serializableCheck: false, // Required when working with redux-persist
            }),
    });

    let persistor = persistStore(store);

    return { store, persistor };
}
